import axios from 'axios';

const BASE_URL = 'https://planeacion.cauca.gov.co/oap/public/api/v2';

const dataMapaService = {
    getProyectos: async () => {
        try {
            // Asegúrate de incluir '/proyectos' al final de la URL
            const response = await axios.get(`${BASE_URL}/proyectos`);
            return response.data; // Retorna los datos al componente
        } catch (error) {
            console.error('Error al obtener los proyectos:', error.message);
            throw error; // Lanza el error para manejarlo en el componente
        }
    },
};

export default dataMapaService;
